import { render, staticRenderFns } from "./campaignsPopup.vue?vue&type=template&id=4fb1af1a&scoped=true&"
import script from "./campaignsPopup.vue?vue&type=script&lang=js&"
export * from "./campaignsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb1af1a",
  null
  
)

export default component.exports